var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandyboxmenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 7C17.25 6.86193 17.1381 6.75 17 6.75C16.8619 6.75 16.75 6.86193 16.75 7C16.75 7.13807 16.8619 7.25 17 7.25C17.1381 7.25 17.25 7.13807 17.25 7ZM17 5.25C17.9665 5.25 18.75 6.0335 18.75 7C18.75 7.9665 17.9665 8.75 17 8.75C16.0335 8.75 15.25 7.9665 15.25 7C15.25 6.0335 16.0335 5.25 17 5.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 12C17.25 11.8619 17.1381 11.75 17 11.75C16.8619 11.75 16.75 11.8619 16.75 12C16.75 12.1381 16.8619 12.25 17 12.25C17.1381 12.25 17.25 12.1381 17.25 12ZM17 10.25C17.9665 10.25 18.75 11.0335 18.75 12C18.75 12.9665 17.9665 13.75 17 13.75C16.0335 13.75 15.25 12.9665 15.25 12C15.25 11.0335 16.0335 10.25 17 10.25Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.223 18.2045C17.5266 18.4863 18.0011 18.4686 18.2829 18.165C18.5721 17.8533 18.75 17.4339 18.75 16.9747C18.75 16.0082 17.9665 15.2247 17 15.2247C16.0335 15.2247 15.25 16.0082 15.25 16.9747C15.25 17.3889 15.5858 17.7247 16 17.7247C16.4142 17.7247 16.75 17.3889 16.75 16.9747C16.75 16.8366 16.8619 16.7247 17 16.7247C17.1381 16.7247 17.25 16.8366 17.25 16.9747C17.25 17.0408 17.2254 17.0994 17.1834 17.1446C16.9016 17.4482 16.9194 17.9228 17.223 18.2045Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 7C12.25 6.86193 12.1381 6.75 12 6.75C11.8619 6.75 11.75 6.86193 11.75 7C11.75 7.13807 11.8619 7.25 12 7.25C12.1381 7.25 12.25 7.13807 12.25 7ZM12 5.25C12.9665 5.25 13.75 6.0335 13.75 7C13.75 7.9665 12.9665 8.75 12 8.75C11.0335 8.75 10.25 7.9665 10.25 7C10.25 6.0335 11.0335 5.25 12 5.25Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 12C12.25 11.8619 12.1381 11.75 12 11.75C11.8619 11.75 11.75 11.8619 11.75 12C11.75 12.1381 11.8619 12.25 12 12.25C12.1381 12.25 12.25 12.1381 12.25 12ZM12 10.25C12.9665 10.25 13.75 11.0335 13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 17C12.25 16.8619 12.1381 16.75 12 16.75C11.8619 16.75 11.75 16.8619 11.75 17C11.75 17.1381 11.8619 17.25 12 17.25C12.1381 17.25 12.25 17.1381 12.25 17ZM12 15.25C12.9665 15.25 13.75 16.0335 13.75 17C13.75 17.9665 12.9665 18.75 12 18.75C11.0335 18.75 10.25 17.9665 10.25 17C10.25 16.0335 11.0335 15.25 12 15.25Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 7C7.25 6.86193 7.13807 6.75 7 6.75C6.86193 6.75 6.75 6.86193 6.75 7C6.75 7.13807 6.86193 7.25 7 7.25C7.13807 7.25 7.25 7.13807 7.25 7ZM7 5.25C7.9665 5.25 8.75 6.0335 8.75 7C8.75 7.9665 7.9665 8.75 7 8.75C6.0335 8.75 5.25 7.9665 5.25 7C5.25 6.0335 6.0335 5.25 7 5.25Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 12C7.25 11.8619 7.13807 11.75 7 11.75C6.86193 11.75 6.75 11.8619 6.75 12C6.75 12.1381 6.86193 12.25 7 12.25C7.13807 12.25 7.25 12.1381 7.25 12ZM7 10.25C7.9665 10.25 8.75 11.0335 8.75 12C8.75 12.9665 7.9665 13.75 7 13.75C6.0335 13.75 5.25 12.9665 5.25 12C5.25 11.0335 6.0335 10.25 7 10.25Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 17C7.25 16.8619 7.13807 16.75 7 16.75C6.86193 16.75 6.75 16.8619 6.75 17C6.75 17.1381 6.86193 17.25 7 17.25C7.13807 17.25 7.25 17.1381 7.25 17ZM7 15.25C7.9665 15.25 8.75 16.0335 8.75 17C8.75 17.9665 7.9665 18.75 7 18.75C6.0335 18.75 5.25 17.9665 5.25 17C5.25 16.0335 6.0335 15.25 7 15.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandyboxmenu);
export default __webpack_public_path__ + "static/media/candy box menu.61f6fbe89d2d1aa6651523060648225c.svg";
export { ForwardRef as ReactComponent };